import { createEventEmitter } from "@made-people/grease-event-emitter";

export interface FaqEventPayload {
  faqClicked: {
    question: string;
    variant: "pdp" | "plp";
    productSku: string | null;
    category: string | null;
  };
}

export const faqEventEmitter = createEventEmitter<FaqEventPayload>();
